var _excluded = ["cons", "consIconProps", "paragraphProps", "pros", "prosIconProps"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Div, P } from '@kizi/core-components';
import { IconV2 as Icon } from './IconV2';
import React from 'react';
export var ProsConsCompare = function ProsConsCompare(_ref) {
  var cons = _ref.cons,
      consIconProps = _ref.consIconProps,
      paragraphProps = _ref.paragraphProps,
      pros = _ref.pros,
      prosIconProps = _ref.prosIconProps,
      divProps = _objectWithoutProperties(_ref, _excluded);

  if (cons.length < 1 && pros.length < 1) return null;
  var hasPros = pros.length > 0;
  var hasCons = cons.length > 0;
  return /*#__PURE__*/React.createElement(Div, _extends({
    display: "flex",
    flexDirection: ['column', 'row']
  }, divProps), hasPros ? /*#__PURE__*/React.createElement(Div, {
    mb: [3, 0],
    width: ['100%', '50%']
  }, pros.map(function (pro, key) {
    var _mb = key < pros.length - 1 ? [3, 1] : 0;

    return /*#__PURE__*/React.createElement(Div, {
      alignContent: "center",
      display: "flex",
      key: "pro-item-".concat(key),
      mb: _mb
    }, /*#__PURE__*/React.createElement(Icon, _extends({
      mr: 2,
      name: "plus",
      variant: "successExtraSmall"
    }, prosIconProps)), /*#__PURE__*/React.createElement(P, _extends({
      variant: "captionRegularSmall"
    }, paragraphProps), pro));
  })) : /*#__PURE__*/React.createElement(React.Fragment, null), hasCons ? /*#__PURE__*/React.createElement(Div, {
    width: ['100%', '50%']
  }, cons.map(function (con, key) {
    var _mb = key < cons.length - 1 ? [3, 1] : 0;

    return /*#__PURE__*/React.createElement(Div, {
      alignContent: "center",
      display: "flex",
      key: "con-item-".concat(key),
      mb: _mb
    }, /*#__PURE__*/React.createElement(Icon, _extends({
      mr: 2,
      name: "minus-big",
      variant: "dangerExtraSmall"
    }, consIconProps)), /*#__PURE__*/React.createElement(P, _extends({
      variant: "captionRegularSmall"
    }, paragraphProps), con));
  })) : /*#__PURE__*/React.createElement(React.Fragment, null));
};